<template>
  <div class="update-box">
    <p>批量更新记录</p>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <template v-for="(item,index) in propsData">

        <el-table-column
          v-if="item.attr === 'status_text'"
          :key="index"
          :prop="item.attr"
          :label="item.name"
          :width="item.columnWidth">
          <template slot-scope="scope">
            <StateBox :value="scope.row.status_text"/>
          </template>
        </el-table-column>
        <el-table-column
          v-else
          :key="index"
          :prop="item.attr"
          :label="item.name"
          :width="item.columnWidth"
        />
      </template>
      <el-table-column
        fixed="right"
        label="操作详情"
        align="center"
        width="200">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="handleSee(scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-box">
      <el-pagination
        :current-page="currentPage"
        :page-size="per_page"
        :total="pageTotal"
        class="app-pagination"
        layout="total, prev, pager, next"
        @current-change="handleCurrentChange"/>
    </div>
    <RecordDetail
      :is-show.sync="isDetail"
      :id="detailId"
      :row="row"
    />
  </div>
</template>

<script>
  import * as CourseListServer from "../../../api/courseList";
  import fields from "./fields";
  import RecordDetail from "../components/RecordDetail/index.vue";
  import StateBox from "../components/StateBox.vue";

  export default {
    name: "UpdateRecord",
    components: {
      RecordDetail,
      StateBox,
    },
    data() {
      return {
        tableData: [],
        propsData: fields,
        isDetail: false, // 是否展示详情
        // 分页参数
        currentPage: 1, // 当前页
        per_page: 10,
        pageTotal: 0,
        detailId: "", // 详情id
        row: "", // 详情数据
      };
    },
    created() {
      this.init();
    },
    methods: {
      init() {
        this.flashTable();
      },
      handleSee(row) {
        console.log("查看==>", row);
        this.detailId = row.id;
        this.row = row;
        this.isDetail = true;
      },
      // 刷新表数据
      async flashTable() {
        const { ids } = this.$route.query;
        // 获取数据
        const res = await CourseListServer.queryUpdateRecordBatch({ course_id: ids, page: this.currentPage });
        this.tableData = res.data.map(v => ({
          id: v.id,
          created_at: v.created_at || '--',
          status_text: v.status_text || '--',
          error_message: v.error_message || '--',
          total_failure: v.total_failure || '--',
          total_success: v.total_success || '--',
          user_realname: v.admin && (v.admin.realname || '--'),
          user_name: v.admin && (v.admin.name || '--'),
        }));
        this.pageTotal = res.total;
      },
      handleCurrentChange(e) {
        console.log("handleCurrentChange==>", e);
        // 翻页更新
        this.currentPage = e;
        this.flashTable();
      },
    },
  };
</script>

<style lang="postcss" scoped>
.update-box{
  padding: 20px 40px;
}
</style>
